import React, { useState } from 'react';

import Loader from '../../components/Loader';
import BasicDetails from '../basicDetails/BasicDetails';

/**
 * Signup component
 * @param {*} param0
 */
const SignUp = ({ submit }) => {
    const [loading, setLoading] = useState(false);

    return (
        <>
            <div className="content signup">
                {loading && <Loader />}
                <div className="content-block-right">
                    <div className="sec-header-block">
                        <h1>Sign Up</h1>
                        <p>
                            Let’s get started! Please share your contact
                            details.
                        </p>
                    </div>
                    <BasicDetails
                        submit={submit}
                        setLoading={setLoading}
                        needCaptcha={true}
                    />
                </div>
            </div>
        </>
    );
};

export default SignUp;
